import { api } from './client';

export interface BodyDto {
  id?: string;
  measurementDate: string;
  heightCm?: number | null;
  weightKg?: number | null;
  neckCm?: number | null;
  chestCm?: number | null;
  waistCm?: number | null;
  hipsCm?: number | null;
  bicepsCm?: number | null;
  note?: string | null;
  createdAt?: string | null;
}

export interface BodyTargetsDto {
  heightCm?: number | null;
  weightKg?: number | null;
  neckCm?: number | null;
  chestCm?: number | null;
  waistCm?: number | null;
  hipsCm?: number | null;
  bicepsCm?: number | null;
}

export const bodyApi = {
  list: () => api<BodyDto[]>('/api/health/body'),
  create: (body: BodyDto) =>
    api<BodyDto>('/api/health/body', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  getTargets: () => api<BodyTargetsDto>('/api/health/body/targets'),
  saveTargets: (t: BodyTargetsDto) =>
    api<BodyTargetsDto>('/api/health/body/targets', {
      method: 'PUT',
      body: JSON.stringify(t),
    }),
};
